<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>Acknowledgements</span></p>
<p class="P_WFP_BodyTextFirstPara">I’ve received much help from reviewers, contributors of anecdotes, historians, former cadets, faculty members, editors, agents, friends, and a host of other people … but all factual errors in the novel are entirely mine, and if not unintended, then were purposely inserted only as embellishment. Thanks to Kevin J. Anderson, Rebecca Moesta, Vivian Trask, Don Erbschloe, Vickie Erbschloe, Matt Bialer, Lori Peterkin and her book club, Lisa Ice, Ken Zeringue, Don Shepherd, Elizabeth Muenger, Joe Gross, Craig Hendrickson, Mike Heil, Bill Sabol, Jeff Dotur, Harald Dogliani, Gary Ganong, Jim Parsons, Bob DeBerry, Hugh Gordon, Deane Burbank, Dick Halloran, Phil Gronseth, Curt McIntyre, Jim Mateos, Chris Jaremko, Yvonne Kinkaid, John Paul Fraser Fisher, Don Cole, Ron Furstenau, Tom McNish, and Beast Beason. The editorial team: Mia Kleve, Holly Smith, Bob Vitas and Michelle Corsillo. Thanks also to my USAFA classmates for reviewing the flying scenes: Robert Massey, Lou Michels, Rick Sowers, George Patterson, Kevin Kenkel, Jack Casey, Kevin Roll, and Bill Ramsay. And of course, without whose love and support this series would never have been possible, Cindy Beason.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0005.vue?6714870d